// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---node-modules-gatsby-plugin-offline-app-shell-js": () => import("./../../../node_modules/gatsby-plugin-offline/app-shell.js" /* webpackChunkName: "component---node-modules-gatsby-plugin-offline-app-shell-js" */),
  "component---node-modules-gatsby-theme-musician-src-pages-404-js": () => import("./../../../node_modules/gatsby-theme-musician/src/pages/404.js" /* webpackChunkName: "component---node-modules-gatsby-theme-musician-src-pages-404-js" */),
  "component---src-gatsby-theme-musician-templates-landing-js": () => import("./../../../src/gatsby-theme-musician/templates/landing.js" /* webpackChunkName: "component---src-gatsby-theme-musician-templates-landing-js" */)
}

